import React, { useRef, useEffect } from "react";
import "../../globalStyles/scss/reset.scss";
import "../../globalStyles/scss/index.scss"
import { Link as GatsbyLink, Link } from "@reach/router";
import LoadingBar from "react-top-loading-bar";
import { CSSTransition } from "react-transition-group";
import { useLocation } from "@reach/router";
import { Cookies, MainMenu, MetaWrapper } from "..";
import { PageCategory, Tag } from "../../core/types";
import { Global } from "@emotion/react";
import { Box, ChakraProvider, Container, Flex, List, ListItem, Text } from "@chakra-ui/react";
import { theme } from "src/utils/theme";
import { generatePageUrl } from "@core/utils";
import FooterPolicy from "@components/Footer/footer";
import { CookiesProvider } from "react-cookie";

interface LayoutProps {
  metaTitle?: string;
  metaType?: string;
  metaDescription?: string;
  categories?: PageCategory[];
  loading?: boolean;
  tags: Tag[];
  isPreview?: boolean;
}

export const Layout: React.FC<LayoutProps> = ({
  children,
  metaTitle,
  metaType,
  metaDescription,
  categories,
  loading = false,
  tags,
  isPreview = false,
  ...rest
}) => {
  return (
    <CookiesProvider>
      <MetaWrapper
        meta={{
          title: `Mamaginekolog`,
          type: metaType,
          description: metaDescription,
        }}
      >
        {(<header>
          <MainMenu metaTitle={metaTitle} categories={categories} tags={tags} />
        </header>)}
        <Box>{children}</Box>
        <Container maxW="1130px" px="15px" mt={{base: '20px', md: '50px'}} mb={{base: '100px', md: 0}} d={{base: 'block', md: 'flex'}} justifyContent="space-between" alignItems="flex-start" spacing="26px" pb="36px">
          <FooterPolicy/>
        </Container>
        <Cookies />
      </MetaWrapper>
    </CookiesProvider>
  );
};
